/**
 * レーダJSON情報取得
 */
import Repository from "../JsonRepository";

const resource = "";

export default {
  /**
   * XRAINレーダ画像情報取得
   * @param level 地域レベル
   */
  getXrainRadarInfo(level) {
    let param = "/" + level + ".json";
    return Repository.get(`${resource}master/radar/xrd` + param);
  },

  /**
   * Cバンドレーダ画像情報取得
   * @param level 地域レベル
   */
  getCbandRadarInfo(level) {
    let param = "/" + level + ".json";
    return Repository.get(`${resource}master/radar/crd` + param);
  },

  /**
   * レーダ観測日時取得
   */
  getRadarDate() {
    return Repository.get(`${resource}radar/rdtime.json`);
  },
};
